/**
 * HeroBackground — iter-64.
 *
 * Shared background renderer for the immersive hero sections.
 *
 * If `videoUrl` is present, an autoplaying looping muted `<video>` is rendered
 * (with the image acting as poster). Otherwise, the classic `<div>` with
 * `background-image` is used. Overlay layers are up to the caller.
 */
export default function HeroBackground({ videoUrl, imageUrl, className = "", testid }) {
  if (videoUrl) {
    return (
      <video
        className={`absolute inset-0 w-full h-full object-cover scale-[1.02] ${className}`}
        src={videoUrl}
        poster={imageUrl || undefined}
        autoPlay
        muted
        loop
        playsInline
        preload="metadata"
        data-testid={testid || "hero-bg-video"}
      />
    );
  }
  return (
    <div
      className={`absolute inset-0 bg-cover bg-center scale-[1.02] ${className}`}
      style={{ backgroundImage: imageUrl ? `url(${imageUrl})` : undefined }}
      data-testid={testid || "hero-bg-image"}
    />
  );
}
